import { render, staticRenderFns } from "./uploadImgs.vue?vue&type=template&id=2d396e54&scoped=true&"
import script from "./uploadImgs.vue?vue&type=script&lang=js&"
export * from "./uploadImgs.vue?vue&type=script&lang=js&"
import style0 from "./uploadImgs.vue?vue&type=style&index=0&id=2d396e54&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d396e54",
  null
  
)

export default component.exports